<template>
	<div>
		<el-dialog :title="title" :visible.sync="visible" width="80%" :before-close="() => handleClose()">
			<el-form style="padding: 0; margin: 0" :inline="true" @keyup.enter.native="refreshList()" @submit.native.prevent>
				<el-form-item>
					<el-input size="small" v-model="searchInput" placeholder="请输入" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="refreshList()" size="small">查询</el-button>
					<el-button @click="resetSearch()" size="small">重置</el-button>
				</el-form-item>
			</el-form>

			<el-table
				v-loading="loading"
				ref="multipleTable"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%; margin-bottom: 20px"
				height="63vh"
				@selection-change="handleSelectionChange"
				:row-key="handleRowKey"
				:tree-props="{ children: 'sku', hasChildren: 'hasChildren' }"
			>
				<el-table-column type="selection" width="55" :selectable="checkSelectable"></el-table-column>
				<el-table-column header-align="center" prop="title" label="产品名称"></el-table-column>
				<el-table-column header-align="center" prop="mainImg" label="产品图片">
					<template slot-scope="scope">
						<div class="main-img">
							<el-image
								v-if="scope.row.sku"
								style="width: 50px; height: 50px"
								:src="scope.row.mainImg"
								:preview-src-list="[scope.row.mainImg]"
							></el-image>
							<el-image
								v-else
								style="width: 50px; height: 50px"
								:src="scope.row.img"
								:preview-src-list="[scope.row.img]"
							></el-image>
						</div>
					</template>
				</el-table-column>
				<el-table-column header-align="center" prop="properties" label="属性名称">
					<template slot-scope="scope" v-if="!scope.row.sku">
						{{ scope.row.properties ? scope.row.properties : "-" }}
					</template>
				</el-table-column>
				<el-table-column header-align="center" prop="supplyPrice" label="供货价格">
					<template slot-scope="scope" v-if="!scope.row.sku">
						{{ scope.row.supplyPrice ? scope.row.supplyPrice : "-" }}
					</template>
				</el-table-column>
				<el-table-column
					align="center"
					header-align="center"
					prop="minSupplyPrice"
					label="最小供货价格"
				></el-table-column>
				<el-table-column
					align="center"
					header-align="center"
					prop="maxSupplyPrice"
					label="最大供货价格"
				></el-table-column>
			</el-table>

			<el-pagination
				@size-change="sizeChangeHandle"
				@current-change="currentChangeHandle"
				:current-page="pageNo"
				:page-sizes="pageSizes"
				:page-size="pageSize"
				:total="total"
				layout="sizes, prev, pager, next, jumper"
			></el-pagination>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" size="medium" @click="handleClose(multipleSelection)">确 定</el-button>
				<el-button size="medium" @click="handleClose()">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { get, postJson } from "@/utils/request.js";
	export default {
		data() {
			return {
				searchInput: "",
				loading: false,
				tableData: [],
				pageNo: 1,
				pageSize: 10,
				pageSizes: [],
				total: 0,
				multipleSelection: null,
			};
		},
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			title: {
				type: String,
				default: "",
			},
		},
		created() {
			this.getProduct();
		},
		methods: {
			handleRowKey(e) {
				return e.proNo ? e.proNo : e.skuNo;
			},
			getProduct() {
				this.loading = true;
				let params = { page: this.pageNo };
				if (this.searchInput) {
					params.keyword = this.searchInput;
				}
				get("/shop/supply-chain/stock/products", params).then((res) => {
					this.loading = false;
					if (res.success && res.code == 200) {
						let { list, total } = res;
						this.total = total * list.length;
						this.pageSize = list.length;
						this.pageSizes = [list.length];
						list = list.map((item) => {
							let sku = item.skuList.map((sku_item) => ({ parentId: item.proNo, ...sku_item }));
							return { ...item, sku };
						});
						this.tableData = JSON.parse(JSON.stringify(list));
					} else {
						this.$message({
							message: res.msg,
							type: "error",
							duration: 2000,
						});
					}
				});
			},
			refreshList() {
				this.pageNo = 1;
				this.getProduct();
			},
			resetSearch() {
				this.pageNo = 1;
				this.searchInput = "";
				this.getProduct();
			},
			// 每页数
			sizeChangeHandle(val) {
				this.pageSize = val;
				this.pageNo = 1;
				this.getProduct();
			},
			// 当前页
			currentChangeHandle(val) {
				this.pageNo = val;
				this.getProduct();
			},
			handleSelectionChange(row) {
				console.log("handleSelectionChange", row);
				this.multipleSelection = row.map((item) => ({
					title: item.title,
					proNo: item.proNo,
				}));
			},
			checkSelectable(row) {
				return !row.parentId;
			},
			handleClose(data) {
				this.$emit("close", data);
			},
		},
	};
</script>

<style lang="scss" scoped>
	::v-deep > .el-dialog {
		margin-top: 5vh !important;
	}
	.main-img {
		display: flex;
		justify-content: center;
	}
</style>
